import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Save } from 'lucide-react';

const SeoTab = ({ seo, setSeo, saving, onSave }) => {
  return (
    <div className="bg-zinc-900 rounded-lg border border-zinc-800 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-white">General SEO Settings</h2>
        <Button onClick={onSave} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>

      <div className="space-y-6">
        <div className="space-y-2">
          <Label className="text-zinc-300">Default Page Title</Label>
          <Input
            value={seo.default_title || ''}
            onChange={(e) => setSeo({ ...seo, default_title: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-zinc-300">Default Meta Description</Label>
          <Textarea
            value={seo.default_description || ''}
            onChange={(e) => setSeo({ ...seo, default_description: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-zinc-300">Default Keywords</Label>
          <Input
            value={seo.default_keywords || ''}
            onChange={(e) => setSeo({ ...seo, default_keywords: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
            placeholder="keyword1, keyword2, keyword3"
          />
        </div>

        <div className="space-y-2">
          <Label className="text-zinc-300">Default OG Image URL</Label>
          <Input
            value={seo.default_og_image || ''}
            onChange={(e) => setSeo({ ...seo, default_og_image: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
            placeholder="https://example.com/og-image.jpg"
          />
        </div>

        <div className="border-t border-zinc-800 pt-6">
          <h3 className="text-white font-medium mb-4">Analytics & Tracking</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label className="text-zinc-300">Google Analytics ID</Label>
              <Input
                value={seo.google_analytics_id || ''}
                onChange={(e) => setSeo({ ...seo, google_analytics_id: e.target.value })}
                className="bg-zinc-800 border-zinc-700 text-white"
                placeholder="G-XXXXXXXXXX"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-zinc-300">Google Search Console</Label>
              <Input
                value={seo.google_search_console || ''}
                onChange={(e) => setSeo({ ...seo, google_search_console: e.target.value })}
                className="bg-zinc-800 border-zinc-700 text-white"
                placeholder="Verification code"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-zinc-300">Facebook Pixel ID</Label>
              <Input
                value={seo.facebook_pixel_id || ''}
                onChange={(e) => setSeo({ ...seo, facebook_pixel_id: e.target.value })}
                className="bg-zinc-800 border-zinc-700 text-white"
                placeholder="XXXXXXXXXXXXXXX"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-6">
          <h3 className="text-white font-medium mb-4">Robots.txt</h3>
          <Textarea
            value={seo.robots_txt || ''}
            onChange={(e) => setSeo({ ...seo, robots_txt: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white font-mono text-sm min-h-32"
          />
        </div>
      </div>
    </div>
  );
};

export default SeoTab;
